// The look of the admin's form fields (components/styledInput): a 12 px grey
// label, a 40 px box, regular text. The CRM fields share it, so that a CRM
// form reads like the others.
export const LABEL_CLASS = "text-xs font-normal leading-4 text-gray-500";
export const FIELD_GAP_CLASS = "gap-1.5";
export const FIELD_BOX_CLASS =
  "rounded-[0.4rem] border bg-white px-3 py-2.5 text-sm font-normal leading-5";
export const SELECT_CLASS =
  "h-10 rounded-[0.4rem] border border-lineStrong bg-white px-3 text-sm font-normal text-gray-900 outline-none focus:border-primary";
